import { useVideoPlayer, VideoView } from "expo-video";
import { FC, useEffect, useRef } from "react";

import { Box } from "./base";

interface VideoPlayerProps {
  aspectRatio?: number;
  className?: string;
  showControls?: boolean;
  uri: string;
}

const VideoPlayer: FC<VideoPlayerProps> = ({
  aspectRatio,
  className = "",
  showControls = true,
  uri,
}) => {
  const currentUri = useRef(uri);

  const player = useVideoPlayer(uri, (player) => {
    player.loop = false;
    player.muted = false;
  });

  // Update player source when URI changes
  useEffect(() => {
    if (player && uri && uri !== currentUri.current) {
      currentUri.current = uri;
      player.replace(uri);
    }
  }, [player, uri]);

  return (
    <Box
      className={`w-full h-full ${className}`}
      style={aspectRatio ? { aspectRatio } : undefined}
    >
      <VideoView
        allowsPictureInPicture
        fullscreenOptions={{ enable: true }}
        contentFit="contain"
        nativeControls={showControls}
        player={player}
        style={{ width: "100%", height: "100%" }}
      />
    </Box>
  );
};

export default VideoPlayer;
